var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1BatteryMidCharged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-6V31h6v14zm9-14h-6v14h6V31zm32 0v14h-5v6a4 4 0 01-4 4H10a4 4 0 01-4-3.86V24.92A4 4 0 0110 21h52a4 4 0 014 4v6h5zm-9-6H10v26h52V25zm-41 6h-6v14h6V31z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Battery_mid_charged.5551d41a.svg";
export { SvgB1BatteryMidCharged as ReactComponent };